import { render, staticRenderFns } from "./letter.nav.vue?vue&type=template&id=f8468100&scoped=true&"
import script from "./letter.nav.vue?vue&type=script&lang=js&"
export * from "./letter.nav.vue?vue&type=script&lang=js&"
import style0 from "./letter.nav.vue?vue&type=style&index=0&id=f8468100&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8468100",
  null
  
)

export default component.exports